import { render, staticRenderFns } from "./TransporterDriverProfile.vue?vue&type=template&id=c2b8623a&scoped=true&"
import script from "./TransporterDriverProfile.vue?vue&type=script&lang=js&"
export * from "./TransporterDriverProfile.vue?vue&type=script&lang=js&"
import style0 from "./TransporterDriverProfile.vue?vue&type=style&index=0&id=c2b8623a&scoped=true&lang=css&"
import style1 from "./TransporterDriverProfile.vue?vue&type=style&index=1&id=c2b8623a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b8623a",
  null
  
)

export default component.exports